import React, { useEffect, useState } from "react";
import { Paper } from "@material-ui/core";
import "./FriendSentInterest.css";
import { Title } from "../../Components/Title/Title";
const siteUrl = process.env.REACT_APP_SITE_URL;
const userSite = siteUrl + "/user";

const FriendSentInterest = () => {
  const paperStyle = {
    height: "auto",
    width: "auto",
    maxWidth: "100%",
    margin: "2% 2%",
    boxShadow: "0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24)",
    borderRadius: "5px",
  };
  return (
    <div className="container sentinterest-container">
      <Paper style={paperStyle}>
        <div className="col headers-container">
          <div className="row justify-content-end header-row">
            <div className="col-8 logo-header">
              <a href={siteUrl}>
                <img
                  src={require(`../../Images/Icons/Logo.png`)}
                  alt="Image"
                  loading="lazy"
                  width="85%"
                  className="logo-header-image"
                />
              </a>
            </div>
            <div className="col-2"></div>
          </div>
        </div>
        <div className="col title-block">
          <h1 className="friends-first-title">מעולה!</h1>
          <h2 className="friends-second-title">נהיה איתך בקשר בקרוב.</h2>
        </div>
        <div className="col main-image">
          <img
            src={require(`../../Images/Other/Other1.png`)}
            width="90%"
            height="100%"
          />
        </div>
        <div className="col below-image-text">
          <span className="blue-text">נ.ב.</span> יש לנו עוד <br /> משרות בשבילך
          <br />
          <br />
        </div>
        <div className="col footer-text container">
          <a href={siteUrl}>
            <div className="blue-text">
              <u>
                לצפייה במשרות<i className="description-arrow left"></i>
              </u>
            </div>
          </a>
        </div>
      </Paper>
    </div>
  );
};

export default FriendSentInterest;
